import {
  SetDefaultData,
  FetchStaticContentTemplateRequest,
  UpdateField,
  UpdateStaticContentTemplateRequest,
} from '../static-content-templates.actions'
import { getUpdateStaticContentTemplateState } from '../static-content-templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map, fromJS } from 'immutable'
import { getLanguagesList } from '@containers/languages/store/languages.selector'
import { FetchLanguagesListRequest } from '@containers/languages/store/languages.actions'
import Swal from 'sweetalert2'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-update-static-content-template',
  templateUrl: './update-static-content-template.component.html',
  styleUrls: ['./update-static-content-template.component.css'],
})
export class UpdateStaticContentTemplateComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public name: string
  public languages$: Subscription
  public languages: any[]
  public selectedLanguage: string
  public initialData: any

  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    public translateService: TranslateService,
  ) {
    super()
  }

  ngOnInit() {
    this.name = this.route.snapshot.paramMap.get('id')
    this.store.dispatch<any>(new SetDefaultData('updateStaticContentTemplate'))
    this.state$ = this.store
      .pipe(select(getUpdateStaticContentTemplateState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (!this.isLoading && state.get('data').size && !this.initialData) {
          this.initialData = state.get('data')
        }
      })

    this.languages$ = this.store
      .pipe(select(getLanguagesList))
      .subscribe((langs) => {
        const languages = langs.get('data').toJS()
        const defaultLanguage = languages.find(
          (lang: any) => lang.isDefault,
        )?.iso2code

        if (!this.selectedLanguage) {
          this.selectedLanguage = defaultLanguage
        }

        this.languages = languages.map((lang: any) => ({
          label: lang.name,
          value: lang.iso2code,
        }))

        if (this.selectedLanguage) {
          this.store.dispatch<any>(
            new FetchStaticContentTemplateRequest(
              this.name,
              this.selectedLanguage,
            ),
          )
        }
      })

    this.store.dispatch<any>(new FetchLanguagesListRequest({}))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.languages$.unsubscribe()
  }

  public languageChange(iso2code: string) {
    if (this.initialData && !this.initialData.equals(this.state.get('data'))) {
      Swal.fire({
        title: this.translateService.instant('ARE_YOU_SURE'),
        text: this.translateService.instant('YOU_HAVE_UNSAVED_CHANGES'),
        icon: 'warning',
        cancelButtonText: 'CANCEL',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateService.instant('CONTINUE'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.initialData = undefined
          this.selectedLanguage = iso2code

          this.store.dispatch<any>(
            new FetchStaticContentTemplateRequest(
              this.name,
              this.selectedLanguage,
            ),
          )
        } else if (result.isDenied) {
        }
      })
    } else {
      this.initialData = undefined
      this.selectedLanguage = iso2code

      this.store.dispatch<any>(
        new FetchStaticContentTemplateRequest(this.name, this.selectedLanguage),
      )
    }
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        e.target?.value || e,
        'updateStaticContentTemplate.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateStaticContentTemplate',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    let rules: any = {}

    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({})

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    let payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateStaticContentTemplateRequest(this.name, payload),
      )
      this.initialData = this.state.get('data')
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateStaticContentTemplate',
        ),
      )
    }
  }
}
